import axiosInstance from "@lib/axios";
import { ChangePasswordRequest } from "../types";

export const editInfo = async (input: ChangePasswordRequest): Promise<void> => {
    await axiosInstance.post("/user/info", input);
};
